import {SingleLayerSettingsLayer} from "../singleLayer/SingleLayerSettingsLayer";
import {Segmented} from "antd";
import {useState} from "react";

export function SplitViewSettingsLayer({
                                           mapOneTheme,
                                           setOneMapTheme,
                                           mapTwoTheme,
                                           setMapTwoTheme
                                       }) {
    const [isRightView, setIsRightView] = useState(true)

    function onChangeView(value) {
        setIsRightView(value === 'Right')
    }

    return (
        <>
            <Segmented
                style={{
                    position: 'absolute',
                    top: 60,
                    right: 0,
                    left: 0,
                }}
                defaultValue="Right"
                options={["Left", "Right"]}
                onChange={onChangeView}
                block/>
            <div style={{height: 20}}></div>
            {!isRightView && <SingleLayerSettingsLayer
                mapTheme={mapOneTheme}
                setMapTheme={setOneMapTheme}
            />}
            {isRightView && <SingleLayerSettingsLayer
                mapTheme={mapTwoTheme}
                setMapTheme={setMapTwoTheme}
            />}
        </>
    )
}